import { render, staticRenderFns } from "./CompetitionCommentComponent.vue?vue&type=template&id=6946aebd&scoped=true"
import script from "./CompetitionCommentComponent.vue?vue&type=script&lang=js"
export * from "./CompetitionCommentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6946aebd",
  null
  
)

export default component.exports